import { render, staticRenderFns } from "./ticketManagement.vue?vue&type=template&id=53b70680&"
import script from "./ticketManagement.vue?vue&type=script&lang=js&"
export * from "./ticketManagement.vue?vue&type=script&lang=js&"
import style0 from "./ticketManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports